import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import Logo from '../assets/logo.png';
import AboutBanner from '../assets/Aboutbanner.jpeg';
import AboutB from '../assets/AboutB1.PNG';
import { Fade } from "react-awesome-reveal";
import { Link } from 'react-router-dom';
import { Slide, Zoom } from 'react-awesome-reveal';
import '../Styles/About.scss';  // using SCSS (you can convert to CSS) 
import CountUp from 'react-countup';

const stats = [
  { value: 100, suffix: '+', label: 'Premium Vehicles' },
  { value: 50, suffix: '+', label: 'Destinations' },
  { value: 10000, suffix: '+', label: 'Happy Customers' },
  { value: 5, suffix: '+', label: 'Years Experience' },
];

const services = [
  {
    number: "01.",
    title: "Energy Performance Certificates",
    description: "Certified EPCs to ensure your property meets legal energy standards.",
  },
  {
    number: "02.",
    title: "Retrofit Assessments",
    description: "Comprehensive assessments to improve energy efficiency and reduce costs.",
  },
  {
    number: "03.",
    title: "Solar Panel Solutions",
    description: "Sustainable solar installations to harness renewable energy.",
  },
  {
    number: "04.",
    title: "Loft & Wall Insulation",
    description: "Improve home comfort and cut energy bills with expert insulation services.",
  },
  {
    number: "05.",
    title: "Boiler & Heating Upgrades",
    description: "High-efficiency boilers and heating systems tailored to your property.",
  },
  {
    number: "06.",
    title: "Green Home Grants Support",
    description: "Helping you access government grants and eco-schemes with ease.",
  },
];


const testimonials = [
  {
    quote: "Reliable and efficient services.",
    text: "Working with Paramount Green Services has been a smooth experience. Their team is professional, responsive, and delivered our energy efficiency project on time with excellent results.",
    name: "Ahmed K.",
    location: "Lahore, Pakistan",
    image: "https://i.pravatar.cc/60?img=12",
    rating: 5,
  },
  {
    quote: "Recommended for energy solutions",
    text: "Paramount Green Services installed insulation and a solar system for us. The work was done with great attention to detail, and the results have significantly reduced our energy bills. Highly recommended!",
    name: "Sarah T.",
    location: "Karachi, Pakistan",
    image: "https://i.pravatar.cc/60?img=30",
    rating: 5,
  },

];

const values = [
  {
    title: 'Safety First',
    description: 'We prioritize the safety and well-being of our clients by delivering solutions that meet the highest industry standards and ensure long-term protection for homes and businesses.',
    iconClass: 'fas fa-shield-alt',
  },
  {
    title: 'Customer Care',
    description: 'We are committed to exceptional service, offering professional guidance, transparent communication, and tailored energy solutions to meet every client’s unique needs.',
    iconClass: 'fas fa-headset',
  },
  {
    title: 'Innovation',
    description: 'We embrace the latest technologies in insulation, renewable energy, and heating systems to deliver smarter, greener, and more efficient solutions.',
    iconClass: 'fas fa-lightbulb',
  },
  {
    title: 'Reliability',
    description: 'From consultation to project completion, we stand by our promise of dependable service, on-time delivery, and consistent quality you can trust.',
    iconClass: 'fas fa-handshake',
  },
];

const team = [
  {
    name: 'ASGHAR ALI RANA',
    role: 'Founder & CEO',
    description: 'Over 10 years of leadership experience, driving innovation and sustainable energy solutions across Pakistan.',
  },
  {
    name: 'SHOAIB RANA',
    role: 'Admin Manager',
    description: 'Responsible for administration and organizational management, ensuring smooth day-to-day operations within the company.',
  },
  {
    name: 'AKASH ANWAR',
    role: 'Project Manager',
    description: 'Skilled in managing renewable energy and insulation projects, dedicated to delivering efficient, reliable, and high-quality solutions.',
  },

];

const About = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleActive = (idx) => {
    setActiveIndex(prev => (prev === idx ? null : idx));
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992); // below 992px = mobile
    };

    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us || Paramount Green Services</title>
        <meta name="description" content="Free heating, insulation, and solar panel grants across the UK. Transform your home’s energy efficiency today." />
      </Helmet>

      <div className="about-page">
        {/* Hero / Banner */}
        <section className="hero-section text-center d-flex align-items-center justify-content-center">
          <div className="overlay"></div>
          <div className="hero-content container">
            <h1 className="hero-title">About Us</h1>
            {/* <p className="hero-subtitle">
              Founded in 2018, Paramount Green Services has been dedicated to making homes and businesses more energy-efficient and sustainable. With expertise in insulation, renewable energy systems, and efficient heating solutions, we combine innovation, quality, and a customer-first approach to create lasting impact for our clients and the environment.
            </p> */}

          </div>
        </section>

        <section className="stats-section py-5">
          <div className="container">
            <div className="row text-center">
              {stats.map((stat, index) => (
                <div key={index} className="col-md-3 col-sm-6 mb-4">
                  {/* Wrap the content in a shadowed box */}
                  <div className="stat-box p-4 text-center">
                    <h3 className="stat-value">
                      <CountUp
                        end={stat.value}
                        duration={2}
                        delay={0.3}
                        suffix={stat.suffix}
                      />
                    </h3>
                    <p className="stat-label">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>



        {/* Our Story Section */}
        <section className="story-section py-5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h2 className="section-heading">Our Story</h2>
                <Fade>
                  <p className="story-text">
                    Paramount Green Services began in 2018 with a simple vision: to provide practical, reliable, and affordable solutions that reduce energy consumption and promote sustainability. We believe that energy efficiency is not just about cutting costs — it’s about building a greener future for generations to come.
                  </p>
                  {/* hide this paragraph on mobile */}
                  {!isMobile && (
                    <p className="Para2">
                      Starting with specialized insulation services, we have steadily expanded into renewable energy systems such as solar panels and air-source heat pumps, as well as modern heating solutions including boilers and central heating systems. Today, Paramount Green Services is proud to handle complete project management — from consultation to execution — trusted by clients across Pakistan for our professionalism, quality, and commitment to excellence.
                    </p>
                  )}

                </Fade>
                <button className="btn btn-success mt-4 mb-4">
                  <Link to="/Contactus/" className="text-white text-decoration-none">Let’s Connect ➔ </Link>
                </button>
              </div>
              <div className="col-md-6">
                <div className="story-image-wrap">
                  <img
                    className="story-image img-fluid rounded"
                    src={AboutBanner}
                    alt="Our Story"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="values-section py-5 bg-light">
          <div className="container text-center">
            <h2 className="section-heading fw-bold"><Fade>Our Values</Fade></h2>
            <p className="section-subheading mb-5">
              We’re driven by these core values to deliver an extraordinary experience every time.
            </p>
            <Zoom>
              <div className="row justify-content-center g-4">
                {values.map((v, idx) => (
                  <div key={idx} className="col-md-6 col-lg-3">
                    <div
                      className={`value-card-modern p-4 h-100 shadow-sm rounded-4 bg-white ${activeIndex === idx ? 'active' : ''}`}
                      onClick={() => toggleActive(idx)}
                    >
                      <div className="icon-wrapper mb-3">
                        <i className={`${v.iconClass} value-icon`}></i>
                      </div>
                      <h5 className="fw-semibold">{v.title}</h5>
                      <p className="text-muted small mt-2">{v.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Zoom>
          </div>
        </section>

        {/* Services Section */}

        <section className="services-section py-5">
          <div className="container text-center">
            <h2 className="section-heading mb-3">Our Services</h2>

            <div className="services-wrapper" role="list">
              {/* center logo / image */}
              <Fade>
                <div className="services-center" aria-hidden="true">
                  <div className="center-logo">
                    {/* Optionally add a photo or initials */}
                    <img
                      src={Logo}
                      alt="Person"
                      style={{ borderRadius: '50%', width: '130px', height: '130px' }}
                    />
                  </div>
                </div>
              </Fade>

              {/* service bubbles */}
              {services.map((svc, idx) => (
                <div key={idx} className={`service-circle service-${idx + 1}`} role="listitem" aria-label={svc.title}>
                  <div className="service-inner milky-sky-bg">
                    <h5 className="service-title">{svc.number} {svc.title}</h5>
                    <p className="service-desc">{svc.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Meet Our Team */}
        <section className="team-section py-5 bg-white">
          <div className="container text-center">
            <h2 className="section-heading"><Fade>Meet Our Team</Fade></h2>
            <p className="section-subheading mb-5">
              A passionate team committed to making your travel dreams come true.
            </p>
            <Zoom>
              <div className="row justify-content-center g-4">
                {team.map((member, idx) => (
                  <div key={idx} className="col-md-6 col-lg-4">
                    <div className="team-card-modern p-4 h-100 text-start rounded-4 shadow-sm bg-light">
                      <div className="team-initials mb-3">
                        {member.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <h5 className="fw-bold mb-1">{member.name}</h5>
                      <p className="text-primary small fw-semibold mb-2">{member.role}</p>
                      <p className="text-muted small">{member.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Zoom>
          </div>
          <Slide direction="down" triggerOnce>
            <div className="container text-center mt-4">
              <button
                className="btn btn-primary btn-modern mt-4 text-center"
                onClick={() => window.location.href = '/ourteam'}
              >
                View Complete Team
              </button>
            </div>
          </Slide>
        </section>


        <section className="testimonials-wrapper py-5">
          <div className="container">
            <div className="row align-items-start mb-5">
              <div className="col-md-4 text-section">
                <p className="section-label">VOICES OF SUCCESS</p>
                <h2 className="section-title">Testimonials from our clients</h2>
                <p className="section-description">
                  Our clients worldover love our work & don’t stay back from saying it loud.
                  Check how much they appreciate our work & processes.
                </p>
                <button className="btn btn-success px-4 py-2 rounded-pill fw-semibold">
                  <a href="https://www.google.com/search?q=Paramount+Green+Services&oq=Paramount+Green+Services&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIICAEQABgWGB4yDQgCEAAYhgMYgAQYigUyDQgDEAAYhgMYgAQYigUyBwgEEAAY7wUyBggFEEUYPTIGCAYQRRg9MgYIBxBFGD3SAQg3MzkxajFqN6gCALACAA&sourceid=chrome&ie=UTF-8" style={{ color: 'white', textDecoration: 'none' }} className='RatingOnG' target='_blank'>View on Google Reviews</a>
                </button>
              </div>

              <div className="col-md-8">
                <div className="d-flex flex-column flex-md-row gap-3">
                  {testimonials.map((item, index) => (
                    <div className="testimonial-card p-4" key={index}>
                      <div className="quote">“{item.quote}”</div>
                      <p className="text">{item.text}</p>
                      <div className="d-flex align-items-center mt-3">
                        <img
                          src={item.image}
                          alt={item.name}
                          className="rounded-circle me-3"
                          width="50"
                          height="50"
                        />
                        <div>
                          <div className="fw-semibold">{item.name}</div>
                          <div className="text-muted small">{item.location}</div>
                          <div className="text-warning stars">
                            {'★'.repeat(item.rating)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Review Ratings */}
            <div className="row text-center review-logos align-items-center justify-content-center">
              <div className="col-md-4 col-sm-6 mb-4 review-item">
                <div className="review-box">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXF-aflLLbl6r3EaDUYV7nZbuu8FykuBn3ZQ&s"
                    alt="Clutch"
                    className="review-logo"
                  />
                  <p className="review-title">Clutch Reviews</p>
                  <p className="review-score text-danger">4.9 ★★★★★</p>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 mb-4 review-item">
                <div className="review-box">
                  <img
                    src="https://cdn.worldvectorlogo.com/logos/trustpilot-2.svg"
                    alt="Trustpilot"
                    className="review-logo"
                  />
                  <p className="review-title">Trustpilot Reviews</p>
                  <p className="review-score text-success">4.7 ★★★★☆</p>
                </div>
              </div>

              <div className="col-md-4 col-sm-6 mb-4 review-item">
                <div className="review-box">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJg75LWB1zIJt1VTZO7O68yKciaDSkk3KMdw&s"
                    alt="Google"
                    className="review-logo"
                  />
                  <p className="review-title">Google Reviews</p>
                  <p className="review-score text-danger">4.8 ★★★★★</p>
                </div>
              </div>
            </div>

          </div>
        </section>


        {/* CTA / Footer Hero */}
        <section className="py-5 text-center text-white">
          <div className="container">
            <h2 className="fw-bold mb-3 text-success">Check Your Eligibility Today</h2>
            <p className="mb-4 text-black">
              Find out what grants you qualify for and start saving on your energy bills immediately.
            </p>

            <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
              <Link to="/Contactus/" className="btn btn-lg eco4-btn-primary">Contact Us</Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
